// extracted by mini-css-extract-plugin
export default {"mCard":"ED-z","image":"FD-z","imageNoBackground":"GD-z","imageHasCategory":"HD-z","fullWidth":"ID-z"};